import PropertyInformationPopoverHorizontalRuleWithSpace from './PropertyInformationPopoverHorizontalRuleWithSpace';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PropertyInformationPopoverLink from './PropertyInformationPopoverLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function PropertyInformationPopoverEditLink({
  editLink
}) {
  if (typeof editLink === 'undefined') {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PropertyInformationPopoverHorizontalRuleWithSpace, {}), /*#__PURE__*/_jsx(PropertyInformationPopoverLink, {
      href: editLink,
      linkType: "edit",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFiltersUI.propertyInformationPopover.viewPropertySetting"
      })
    })]
  });
}